import React from "react";
import { Link } from "react-router-dom";

const PublicHeader: React.FC = () => {
  return (
    <header className="w-full flex justify-between items-center px-6 py-4 bg-agri-cream-50/95 backdrop-blur shadow-sm border-b border-amber-200/50 z-10">
      <div className="flex items-center space-x-2">
        <img
          src="/favicon.png"
          alt="AgriFlow logo"
          className="w-10 h-10 object-contain"
        />
        <span className="font-display text-xl font-bold text-agri-forest-900">
          AgriFlow Food Hub
        </span>
      </div>
      <div className="flex items-center space-x-4">
        <Link
          to="/auth/login"
          className="btn-primary px-4 py-2"
        >
          Login
        </Link>
        <Link
          to="/admin/login"
          className="btn-secondary px-4 py-2"
        >
          Admin Login
        </Link>
      </div>
    </header>
  );
};

export default PublicHeader;
